function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center text-white bg-gray-950">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p>Wird geladen...</p>
      </div>
    </div>
  );
}

export default Loading;
